export const JWPLAYER_SDK = 'https://cdn.jwplayer.com/libraries/xbpgBeUj.js';
export const PREROLL_ID = 'preroll';
